import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { DateTime } from "luxon"
import InputGroup from "react-bootstrap/InputGroup"

import "./index.scss"
import { Container, Title, Select, Text } from "components/Form"
import { ConfigContainer, Popup } from "components"
import { projectActions } from "state_management"
import Button from "react-bootstrap/Button"
import useT from "utils/hooks/useT"

// Filter config for actions in To Do list on teamplan
export default function FilterActionsConfig({ cancelHandler }) {
  // Values
  const competenceGroups = useSelector((state) => state.competenceGroups)

  // filtersettings is saved in the visual state. It is therefore saved in local storage
  const filterSettings = useSelector((state) => state.visual.filterSettings)

  // Checkboxes
  const [shouldApplyCompetenceGroupFilter, setShouldApplyCompetenceGroupFilter] = useState(
    filterSettings.isCompetenceGroupFilter
  )
  const [shouldApplyDeadlineFilter, setShouldApplyDeadlineFilter] = useState(filterSettings.isDeadlineFilter)
  const [scrumViewOrder, setScrumViewOrder] = useState(filterSettings.scrumViewOrder)
  // Values
  const [competenceGroupFilter, setCompetenceGroupFilter] = useState(filterSettings.competenceGroupFilter)
  const [deadlineStart, setDeadlineStart] = useState(
    filterSettings.deadlineStart ? DateTime.fromISO(filterSettings.deadlineStart) : null
  )
  const [deadlineEnd, setDeadlineEnd] = useState(
    filterSettings.deadlineEnd ? DateTime.fromISO(filterSettings.deadlineEnd) : null
  )

  const dispatch = useDispatch()
  const { t } = useT("common")

  const handleCompetenceGroupChange = (items) => {
    setCompetenceGroupFilter(items);
    setShouldApplyCompetenceGroupFilter(items.length === 0 ? false : true);
  };

  return (
    <Popup onCancel={cancelHandler}>
      <ConfigContainer
        title={t("filter")}
        submitHandler={() => {
          dispatch(
            projectActions.filterUnplanned(
              shouldApplyCompetenceGroupFilter,
              shouldApplyDeadlineFilter,
              competenceGroupFilter,
              scrumViewOrder,
              deadlineStart ? deadlineStart.toISO() : null,
              deadlineEnd ? deadlineEnd.toISO() : null,
            )
          )
          cancelHandler()
        }}
        cancelHandler={cancelHandler}
      >
        <Container marginBottom="mb-4">
          <InputGroup>
            <Title>{t("byDeadline")}</Title>
            <Title>{t("from")}</Title>
            <Text
              type="date"
              required={shouldApplyDeadlineFilter && !deadlineEnd}
              value={deadlineStart ? deadlineStart.toFormat("yyyy-MM-dd") : ""}
              onChange={(value) => {
                if (!value) {
                  setDeadlineStart(undefined)
                  setShouldApplyDeadlineFilter(deadlineEnd ? true : false)
                  return
                }
                try {
                  const newDate = DateTime.fromFormat(value, "yyyy-MM-dd")
                  setDeadlineStart(newDate)
                  setShouldApplyDeadlineFilter(true)
                } catch {
                  // Handle invalid date format
                }
              }}
            />
            <Title>{t("to")}</Title>
            <Text
              type="date"
              required={shouldApplyDeadlineFilter && !deadlineStart}
              value={deadlineEnd ? deadlineEnd.toFormat("yyyy-MM-dd") : ""}
              onChange={(value) => {
                if (!value) {
                  setDeadlineEnd(undefined)
                  setShouldApplyDeadlineFilter(deadlineStart ? true : false)
                  return
                }
                try {
                  const newDate = DateTime.fromFormat(value, "yyyy-MM-dd")
                  setDeadlineEnd(newDate)
                  setShouldApplyDeadlineFilter(true)
                } catch {
                  // Handle invalid date format
                }
              }}
            />
            <Button variant="danger" style={{marginLeft: "auto", borderRadius: "0.25rem", boxShadow: "none"}} onClick={() => {
              setDeadlineStart(undefined);
              setDeadlineEnd(undefined);
              setShouldApplyDeadlineFilter(false);
            }}>
              {t("clearDates")}
            </Button>
          </InputGroup>
        </Container>
        <Container marginBottom="mb-4">
          <InputGroup>
            <Title className="Filter-ByGroup">{t("byCompetenceGroup")}</Title>
            <Select
              required={shouldApplyCompetenceGroupFilter}
              collection={Object.values(competenceGroups).sort((a, b) => {
                if (a.name.toUpperCase() < b.name.toUpperCase()) return -1
                if (a.name.toUpperCase() > b.name.toUpperCase()) return 1
                return 0
              })}
              value={competenceGroupFilter}
              onChange={handleCompetenceGroupChange}
              menuPosition="fixed"
            />
          </InputGroup>
        </Container>
        <Container marginBottom="mb-4">
          <Title className="Filter-ByGroup">{t("scrumViewOrdering")}</Title>
          <input
            type="checkbox"
            defaultChecked={scrumViewOrder}
            onClick={() => setScrumViewOrder(!scrumViewOrder)}
            style={{ marginLeft: "1.5em" }}
          />
        </Container>
      </ConfigContainer>
    </Popup>
  )
}
